// src/features/brain/BrainEmptyState.tsx
// Phase 6.6 Bundle 3.2 - Brain empty state.
//
// Shown when no conversation is active. Presents four canned example
// questions that exercise core property-management queries. Tapping a
// chip dispatches the question to the chat (via onPick callback).

import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

interface BrainEmptyStateProps {
  onPick: (question: string) => void;
  disabled?: boolean;
}

export function BrainEmptyState({ onPick, disabled }: BrainEmptyStateProps) {
  const { t } = useTranslation();

  const prompts = [
    t("brain.prompt1"),
    t("brain.prompt2"),
    t("brain.prompt3"),
    t("brain.prompt4"),
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-6 py-12 text-center">
      <div className="mb-4 rounded-full bg-maple-100 p-3">
        <Sparkles className="h-6 w-6 text-maple-600" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        {t("brain.emptyHeading")}
      </h3>
      <p className="text-sm text-muted-foreground mb-6">
        {t("brain.emptyHint")}
      </p>
      <div className="w-full max-w-md space-y-2">
        {prompts.map((prompt, idx) => (
          <button
            key={idx}
            type="button"
            disabled={disabled}
            onClick={() => onPick(prompt)}
            className="w-full text-left px-4 py-3 rounded-lg border border-border bg-card text-sm text-foreground hover:bg-accent hover:text-accent-foreground transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px]"
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}